import { render, staticRenderFns } from "./OcrCanvas.vue?vue&type=template&id=6f1dea4e&scoped=true&lang=pug"
import script from "./OcrCanvas.vue?vue&type=script&lang=js"
export * from "./OcrCanvas.vue?vue&type=script&lang=js"
import style0 from "./OcrCanvas.vue?vue&type=style&index=0&id=6f1dea4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1dea4e",
  null
  
)

export default component.exports